import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

const LoadingSpinner: React.FC = () => (
  <div className="main-spinner-container" data-testid="spinner-container">
    <CircularProgress color="primary" />
  </div>
);

export default LoadingSpinner;
